import { useEffect, useState, useRef } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { motion } from "framer-motion";
import PowerBIReportEmbebed from "./PowerBIReportEmbebed";
import { BiMenu } from "react-icons/bi";
import { useLocalStorage } from "../useLocalStorage";
import LogoPbi from "../assets/images/home/logo_pbi.png"
import { Navbar, Nav, Container, NavDropdown, NavbarBrand } from "react-bootstrap";
import imgIconoLogin from "../assets/images/avatar.png"
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import News from "./News";


const PowerBIReportsSidebarVF = ({ token, workspaceid,user, onLogout }) => {
  // Estados
  const [negocios, setNegocios] = useState([]);
  const [dominios, setDominios] = useState([]);
  const [reportes, setReportes] = useState([]);
  const [news, setNews] = useState([]);
  const [reportesxusuario, setReportesxusuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [selectedReportIdUltimaActualizacion, setSelectedReportIdUltimaActualizacion] = useState(null);
  const [selectedReportIdUltimaActualizacionHora, setSelectedReportIdUltimaActualizacionHora] = useState(null);
  const [selectedGroupId, setelectedGroupId] = useState(null);
  const [selectedNegocioId, setSelectedNegocioId] = useState(null);
  const [selectedDominioId, setSelectedDominioId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [nameReport, setnameReport] = useLocalStorage('nameReport',null);
  const [embedToken, setEmbedToken] = useState(null);

  const { instance } = useMsal();
  const intervalRef = useRef(null);

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  };

  const userAuth = getAccountInfo();

  const servidor = "https://analytics.centenario.com.pe";
  //const servidor = "http://localhost:3000";
  //const servidor = process.env.REDIRECT_URI;

  

  // Funciones de selección
  const handleNegocioSelect = (id) => {
    setSelectedNegocioId(id);
    setSelectedDominioId(null);
    if(id == 9)
    {
      setSelectedReportIdUltimaActualizacion(null);
    }
    //setSelectedReportId(null);
  };

  const handleDominioSelect = (id) => {
    setSelectedDominioId(id);
    //setSelectedReportId(null);
  };

  const handleReportSelect = (id,groupid,name,ultimaactualizacion) => {

    //actualiza el token
    fetchToken();

    setSelectedReportId(id);

    fetchData();

    {reportes.filter((reporte) => reporte.ReporteID === id).map((reporte) => (
      ultimaactualizacion = reporte.UltimaActualizacionDataSet
    ))}

    const fecha = new Date(ultimaactualizacion);

    const anio = fecha.getUTCFullYear();
    const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getUTCDate()).padStart(2, '0');
    const horas = String(fecha.getUTCHours()).padStart(2, '0');
    const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
    const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

    const fechaConvertida = `${anio}-${mes}-${dia}`;
    const fechaConvertidaHora = `${horas}:${minutos}:${segundos}`;

    setSelectedReportIdUltimaActualizacion(fechaConvertida);
    setSelectedReportIdUltimaActualizacionHora(fechaConvertidaHora);
    setelectedGroupId(groupid);
    setnameReport(name);
    window.dispatchEvent(new Event("storage_name")); // Dispara el evento manualmente
    //console.log("Reporte seleccionado:", id);
  };

  // Obtener datos desde API
  const fetchData = async () => {
    try {
      const [negociosRes, dominiosRes, reportesRes, reportesUsuario, listNews] = await Promise.all([
        axios.get(`${servidor}/api/negocios`),
        axios.get(`${servidor}/api/dominios`),
        axios.get(`${servidor}/api/reportes`),
        axios.get(`${servidor}/api/reportesxusuario?correo=${user.name}`),
      ]);

      setNegocios(negociosRes.data);
      setDominios(dominiosRes.data);
      setReportes(reportesRes.data);
      setReportesxusuarios(reportesUsuario.data);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };


  // Registro de Visitas
  useEffect(() => {

    

    if(selectedReportId != null && user !=  null)
    {
      //console.log("selectedReportId:", selectedReportId);
      //console.log("user.email:", user);

      const registerVisit = async () => {
        try {
            const ip = await getUserIP();
            //console.log("IP obtenida:", ip);

            await axios.post(`${servidor}/api/visitas`, {
                report_id: selectedReportId,
                user_id: user.email,
                ip_address: ip,
            });
        } catch (error) {
            console.error("Error registrando la visita:", error);
        }
    };

    const getUserIP = async () => {
        try {
            const response = await axios.get("https://api64.ipify.org?format=json");
            return response.data.ip;
        } catch {
            return "0.0.0.0";
        }
    };

    registerVisit();
    }

}, [selectedReportId, user.email]);

  useEffect(() => {
    fetchData();
    localStorage.removeItem("nameReport"); // Eliminar del almacenamiento local
    setnameReport(null);
  }, []);


  useEffect(() => {
    const handleStorageChange = () => {
      const storedValue = localStorage.getItem("isSidebarOpen") === "true";
      setIsSidebarOpen(storedValue);
    };
  
    // Establecer el estado inicial basado en localStorage
    handleStorageChange();
    
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);

  }, []);


  setInterval(() => {
    const storedValue = localStorage.getItem("isSidebarOpen") === "true";
    setIsSidebarOpen(storedValue);
    //toast.info("ℹ️ Nueva noticia disponible");
  }, 1000); // Verifica cada segundo
  

    const fetchToken = async () => {

      if (!userAuth) {
        await instance.loginPopup({
          scopes: ["https://analysis.windows.net/powerbi/api/.default"],
        });
      }

      try {
        const tokenResponse = await instance.acquireTokenSilent({
          scopes: ["https://analysis.windows.net/powerbi/api/.default"],
          account: userAuth,
        });

        setEmbedToken(tokenResponse.accessToken);
      } catch (error) {
        console.error("Error al obtener el token aqui:", error);
      }
  };

    const fetchDataNews = async () => {
      try {
        const [newsRes] = await Promise.all([
          axios.get(`${servidor}/api/listnews`),
        ]);
  
        setNews(newsRes.data);

        // 🔹 Hora actual en Lima (PE)
        const now = new Date(
          new Date().toLocaleString("en-US", { timeZone: "America/Lima" })
        );

        // Mostrar notificaciones
        newsRes.data.forEach((n) => {

          const dateIni = new Date(n.DateIni);
          const dateFin = new Date(n.DateFin);

          if((now >= dateIni && now <= dateFin) && (n.IsEnabled == 1) && (n.IsPushed == 1))
          {
           toast.info(
              <div>
                <strong>{n.Title}</strong>
                <div>{n.Message}</div>
              </div>,
              {
                autoClose: 20000, // 20 segundos
              }
            );
          }
        });

        setLoading(false);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    const startInterval = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          if (document.visibilityState === "visible") {
            fetchDataNews();
          }
        }, 1800000); // 1800000 30 min
      }
    };

      const clear = () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };

      useEffect(() => {
    // Llamada inicial
      if(news.length === 0)
      {
        fetchDataNews();
      }

      // Arrancar intervalo solo cuando la página está visible
      if (document.visibilityState === "visible") {
        startInterval();
      }

      const handleVisibility = () => {
        if (document.visibilityState === "visible") {
          startInterval();
        } else {
          clear();
        }
      };

      document.addEventListener("visibilitychange", handleVisibility);

      // Cleanup al desmontar
      return () => {
        clear();
        document.removeEventListener("visibilitychange", handleVisibility);
      };
    
  }, []);
  

  return (
    <div className="d-flex" style={{overflow:"hidden"}}>
      {/* Botón para abrir/cerrar el Sidebar */}
      

      {/* Sidebar */}
      <div className={`sidebar bg-dark text-white p-3 ${isSidebarOpen ? "d-block" : "d-none"}`} style={{ width: "300px" }}>
    
        
        <div className="accordion" id="sidebarAccordion" style={{overflow:"auto"}}>
          {negocios.map((negocio, negocioIndex) => (
            <motion.div key={negocio.NegocioID} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="accordion-item text-white">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${selectedNegocioId === negocio.NegocioID ? "selected" : ""}`}
                  onClick={() => handleNegocioSelect(negocio.NegocioID)}
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-negocio-${negocioIndex}`}
                  aria-expanded="true"
                  aria-controls={`collapse-negocio-${negocioIndex}`}
                >
                  {negocio.Descripcion}
                </button>
              </h2>
              <div id={`collapse-negocio-${negocioIndex}`} className="accordion-collapse collapse" data-bs-parent="#sidebarAccordion">
                <div className="accordion-body" style={{overflowY:"scroll"}}>
                  <ul className="list-unstyled">
                    {dominios.filter((dominio) => dominio.NegocioID === negocio.NegocioID).map((dominio, dominioIndex) => (
                      <li key={dominio.DominioID} className="mb-2">
                        <button
                          className={`btn btn-link text-white text-decoration-none ${selectedDominioId === dominio.DominioID ? "selected" : ""}`}
                          onClick={() => handleDominioSelect(dominio.DominioID)}
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-dominio-${negocioIndex}-${dominioIndex}`}
                          aria-expanded="false"
                          aria-controls={`collapse-dominio-${negocioIndex}-${dominioIndex}`}
                          style={{ fontSize: "9pt", fontFamily:"montserrat-extrabold" }}
                        >
                          {dominio.Nombre}
                        </button>
                        <div id={`collapse-dominio-${negocioIndex}-${dominioIndex}`} className="collapse">
                          <ul className="list-unstyled">
                            {reportes.filter((reporte) => reporte.DominioID === dominio.DominioID).map((reporte) => (
                              <li
                                key={reporte.ReporteID}
                                className={`list-group-item bg-dark text-white m-2 report-item ${selectedReportId === reporte.ReporteID ? "selected" : ""}`}
                                onClick={() => handleReportSelect(reporte.ReporteBI,reporte.GrupoBI,reporte.Titulo,reporte.UltimaActualizacionDataSet)}
                              >
                                {reporte.Nombre}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        <br></br>
        {selectedReportIdUltimaActualizacion && (
        <div style={{
          padding: "20px",
          fontFamily: "Montserrat, sans-serif",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          
          maxWidth: "300px",
          margin: "20px auto",
          textAlign: "left"
        }}>
          <h3 style={{
            fontSize: "10pt",
            fontWeight: "bold",
            marginBottom: "10px",
            color: "#555"
          }}>
            Última Actualización
          </h3>
          <p style={{
            fontSize: "10pt",
            margin: "5px 0",
            color: "#555"
          }}>
            <strong>Fecha:</strong> {selectedReportIdUltimaActualizacion}
          </p>
          <p style={{
            fontSize: "10pt",
            margin: "5px 0",
            color: "#555"
          }}>
            <strong>Hora:</strong> {selectedReportIdUltimaActualizacionHora}
          </p>
        </div>
      )}

      </div>

      {/* Contenido principal */}
      <div className="p-4 flex-grow-1" style={{overflow:"hidden", height:"90vh"}}>
        {selectedReportId ? (
          <PowerBIReportEmbebed reportId={selectedReportId} groupId={selectedGroupId} embedToken={embedToken} />
        ) : (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
            
          {(news.some((n) => n.IsEnabled)) ? <News></News> : <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "calc(24em + 15vw)" }}>
              <h4 className="mt-3">Cargando contenido espere...</h4>
            </div>}
            
          </motion.p>
        )}
      </div>
    </div>
  );
};

export default PowerBIReportsSidebarVF;


const styles = `
  .sidebar {
    background: #ffffff; /* Fondo blanco */
    padding: 20px;
    border-right: 3px solid #d32f2f; /* Rojo corporativo */
    height: 100vh;
    overflow: hidden; /* Oculta el scroll */
    background-color: lightblue;
  }
  .accordion-item {
    background: transparent;
    border: none;
  }
  .accordion-button {
    background: transparent;
    color: #d32f2f; /* Rojo corporativo */
    border: none;
    transition: color 0.3s ease-in-out, border-bottom 0.3s ease-in-out;
    font-size: 9pt;
    font-family: 'montserrat-extrabold';
  }
  .accordion-button:hover, .selected {
    color: #ffffff; /* Blanco */
    background-color: #d32f2f; /* Rojo corporativo */
    border-bottom: 3px solid #d32f2f; /* Rojo corporativo */
    font-family: 'montserrat-extrabold';
    font-size: 9pt;
  }
  .btn:hover, .selected{
    color: #ffffff; /* Blanco */
    background-color: #d32f2f; /* Rojo corporativo */
    border-bottom: 3px solid #d32f2f; /* Rojo corporativo */
    font-family: 'montserrat-extrabold';
    font-size: 9pt;
  }
  .list-group-item {
    cursor: pointer;
    transition: color 0.3s ease-in-out, border-bottom 0.3s ease-in-out;
    background: transparent;
    color: #d32f2f; /* Rojo corporativo */
    font-family: 'montserrat-extrabold';
  }
  .list-group-item:hover, .selected {
    color: #ffffff; /* Blanco */
    background-color: #d32f2f; /* Rojo corporativo */
    border-bottom: 3px solid #d32f2f; /* Rojo corporativo */
    font-family: 'montserrat-extrabold';
    font-size: 9pt;
  }
  .report-item {
    padding-left: 20px;
    font-size: 9pt;
    font-family: 'montserrat-extrabold';
  }
  .list-group-item:hover, .selected { 
    color: #d32f2f; 
    border-bottom: 3px solid #d32f2f; 
    font-family: 'montserrat-extrabold';
    font-size: 9pt;
  }
  .accordion-button{
    background-color:#ffffff !important;
  }
    .accordion-body {
    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
    max-height: 55vh; /* Puedes ajustar esta altura a lo que necesites */
    overflow-y: auto;  /* Muestra el scroll solo si el contenido excede el max-height */

    /* Para Firefox */
    scrollbar-width: thin;
    scrollbar-color: red transparent !important;
  }
    /* Para Chrome, Edge y Safari (WebKit) */
.accordion-body::-webkit-scrollbar {
    width: 6px; /* Grosor del scroll */
}

.accordion-body::-webkit-scrollbar-track {
    background: transparent; /* Fondo del track (puedes poner otro color si quieres) */
}

.accordion-body::-webkit-scrollbar-thumb {
    background-color: red; /* Color del scroll */
    border-radius: 4px;
}
`;

const styleTag = document.createElement("style");
styleTag.innerHTML = styles;
document.head.appendChild(styleTag);
